module.exports = __webpack_public_path__ + "static/media/analytics.24bf5fa9.svg";